import {useAppStore} from '@/stores'
import {messenger} from '@communication'

export default class ChangeStrategyProcedure {
  constructor() {
    this.name = 'changeStrategyProcedure'
    this.appStore = useAppStore()
    this.state = {
      strategyReady: false,
      counterpartyStrategyReady: false,
      callback: null,
    }
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:changing', this.handleStrategyChanging)
    messenger.subscribe(this.name, 'strategy:changed', this.handleStrategyChanged)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handleStrategyChanging = () => {
    this.appStore.loading('Please wait, we are changing the session configuration')
  }
  handleStrategyChanged = () => {
    this.appStore.loaded()
  }
}
